module.exports = __webpack_public_path__ + "img/popup-manage-kid.a092bfa8.svg";